// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import scrollDir from 'third/scrolldir.js';
import classNames from 'fg-frontend/src/lib/classNames';
import { isTouchDevice } from 'fg-frontend/plugins/utils';

export default class WebLayout extends WebComponent {

  constructor(props) {
    super(props);
    this.scrollFn = this.scrollFn.bind(this);
    this.fixOwLayout = this.fixOwLayout.bind(this);
    this.state = {
      btnFixed: true,
    };
  }

  didMount() {
    scrollDir({ el: this.element });
    this.lastScrollTop = 0;
    this.header = this.element.querySelector('.header');
    this.btnTop = this.element.querySelector('.btn-top');
    this.loggedIn = this.header.querySelector('.header-links__item--user');
    this.finishButton = document.querySelector('.page-container--order-summary #finish');

    if (this.loggedIn) document.body.classList.add('user-logged-in');
    if (isTouchDevice()) this.element.classList.add('touch-device');

    // hidden input to pass the actual page where the feedback came from
    // this will show the URL in form results preview
    this.url = document.getElementById('url');
    if (this.url) this.url.value = window.location.pathname;


    // feature request https://gitlab.fg.cz/prj/p_mos.moser/-/commit/9509fdb42b329dde5993fa253bcf0449a4279e39
    const faqDetailForm = document.querySelector('.faq-detail-form');
    if (faqDetailForm) {
      const faqDetailBtnConfirm = faqDetailForm.querySelector('.faq-detail-form button');
      const radios = faqDetailForm.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.addEventListener('click', () => {
          faqDetailBtnConfirm.click();
        });
      });
    }

    // Additional noPartialUpdate class to links in wysiwyg content
    const wysiwygLinks = document.querySelectorAll('.wysiwyg-content a');
    if (wysiwygLinks) {
      wysiwygLinks.forEach((link) => {
        link.classList.add('noPartialUpdate');
      });
    }


    window.addEventListener('scroll', this.scrollFn);

    if (this.finishButton && this.state.btnFixed) {
      this.btnContainer = this.finishButton.parentElement;
      this.finishButton.classList.add('btn-fixed');
      // underlay for button
      const underlay = document.createElement('span');
      underlay.classList.add('btn-fixed-underlay');
      underlay.style.display = 'none';
      this.btnContainer.appendChild(underlay);
    }
    // fixing grid in order wizard as grid is still rubbish in masonry layout
    this.summaryContainer = document.querySelector('.page-container--order-summary');
    if (this.summaryContainer) {
      this.owProductList = document.querySelector('.page-container--order-summary .product-list-table-shopping-cart');
      this.owProductListOffsetBottom = this.owProductList.offsetTop + Math.ceil(this.owProductList.offsetHeight);
      this.owPriceSum = document.querySelector('.page-container--order-summary .order-price-sum-wrapper');
      this.owBtnContainer = document.querySelector('.page-container--order-summary .order-wizard__btn-container');

      this.fixOwLayout();
      window.addEventListener('resize', this.fixOwLayout);
    }
  }

  fixOwLayout() {
    if (window.innerWidth >= 1280) {
      if (this.owPriceSum.offsetTop > this.owProductListOffsetBottom) {
        const diff = Math.ceil(this.owPriceSum.offsetTop - this.owProductListOffsetBottom);
        this.owPriceSum.style.marginTop = `${-diff}px`;
        // this.owBtnContainer.style.marginTop = `${-Math.ceil(this.owBtnContainer.offsetTop - this.owProductListOffsetBottom) + diff  }px`;
      }
    } else {
      this.owPriceSum.style.marginTop = `${0}px`;
      this.owBtnContainer.style.marginTop = `${0}px`;
    }
  }

  scrollFn(e) {
    if (this.header) {
      let scrollDirText = this.element.dataset.scrolldir;
      let st = window.pageYOffset || document.documentElement.scrollTop;
      this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

      if (scrollDirText == 'down'){
        if (st > 300) {
          this.header.classList.remove('header--fade-in');
          this.header.classList.add('header--mobile-hidden');
        }
      }else {
        this.header.classList.add('header--fade-in');
        this.header.classList.remove('header--mobile-hidden');
      }

      if (window.innerWidth >= 1280) {
        if (st > 300) {
          this.header.classList.add('header--fixed');
        } else {
          this.header.classList.remove('header--fixed');
        }
      } else {
        if (st > 30) {
          this.header.classList.add('header--fixed');
        } else {
          this.header.classList.remove('header--fixed');
        }
      }

      if (st < 500) {
        this.header.classList.remove('header--fade-in');
      }

      // reset scroll dir
      if (this.lastScrollTop == 0) {
        this.element.dataset.scrolldir = 'down';
      }
    }

    if (this.btnTop) {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > 800) {
        this.btnTop.classList.add('visible');
      } else {
        this.btnTop.classList.remove('visible');
      }
    }

    if (this.finishButton) {
      var isInViewport = function (elem) {
        var bounding = elem.getBoundingClientRect();
        return (
          bounding.top >= 0 && Math.ceil(bounding.top + 80) <= (window.innerHeight || document.documentElement.clientHeight)
        );
      };
      if (isInViewport(this.btnContainer)) {
        this.setState({ btnFixed: false });
      } else {
        this.setState({ btnFixed: true });
      }
    }
  }

  update = () => {
    const {
      btnFixed,
    } = this.state;
    if (this.finishButton) classNames(this.finishButton, { 'btn-fixed': btnFixed });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js